import React from 'react';
import CheckButton from '../../components/CheckButton';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckAnxiety: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 20) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (0 <= total && total < 22) {
                    resultCode = "001";
                } else if (21 < total && total < 36) {
                    resultCode = "002";
                } else if (total > 35) {
                    resultCode = "003";
                }
                window.location.href=`/psychlgclCheck/anxiety/result/${resultCode}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='불안 자가진단'
                        />
                        <div className="mobileface testing">
                            <div className="testWrap nervous">
                                <h3 className="f18 black">불안 자가진단</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30"> <strong className="f16"> 현재의 상태에 가장 근접하다고 생각되는 것에 체크해 주십시오.</strong></p>
                                </div>
                                <h4 className="f14 green mt30">불안 자가진단 진행 (21문항)</h4>
                                    <fieldset>
                                        <ul className="etc_list col4">
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">1. 가끔씩 몸이 저리고 쑤시며 감각이 마비된 느낌을 받는다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq1" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq1" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq1" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq1" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">2. 흥분된 느낌을 받는다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq2" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq2" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq2" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq2" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">3. 가끔씩 다리가 떨리곤 한다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq3" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq3" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq3" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq3" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">4. 편안하게 쉴 수가 없다.</dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq4" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq4" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq4" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq4" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">5. 매우 나쁜 일이 일어날 것 같은 두려움을 느낀다.</dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq5" value="0" /> 전혀 없다</label>
                                                        <label><input type="radio" name="aq5" value="1" /> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq5" value="2" /> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq5" value="3" /> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">6. 어지러움(현기증)을 느낀다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq6" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq6" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq6" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq6" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">7. 가끔씩 심장이 두근거리고 빨리 뛴다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq7" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq7" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq7" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq7" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">8. 침착하지 못하다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq8" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq8" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq8" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq8" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">9. 자주 겁을 먹고 무서움을 느낀다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq9" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq9" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq9" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq9" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">10. 신경이 과민 되어 왔다.  </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq10" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq10" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq10" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq10" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">11. 가끔씩 숨이 막히고 질식할 것 같다.</dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq11" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq11" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq11" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq11" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">12. 자주 손이 떨린다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq12" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq12" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq12" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq12" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">13. 안절부절 못해 한다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq13" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq13" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq13" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq13" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">14. 미칠 것 같은 두려움을 느낀다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq14" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq14" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq14" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq14" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">15. 가끔씩 숨쉬기 곤란할 때가 있다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq15" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq15" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq15" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq15" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">16. 죽을 것 같은 두려움을 느낀다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq16" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq16" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq16" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq16" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">17. 불안한 상태에 있다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq17" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq17" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq17" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq17" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">18. 자주 소화가 잘 되지 않고 뱃속이 불편하다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq18" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq18" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq18" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq18" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">19. 가끔씩 기절할 것 같다. </dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq19" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq19" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq19" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq19" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">20. 자주 얼굴이 붉어지곤 한다.</dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq20" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq20" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq20" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq20" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                            <li>
                                                <dl>
                                                    <dt className="mt5 lh18">21. 땀을 많이 흘린다. (더위로 인한 경우는 제외)</dt>
                                                    <dd className="mt15 space">
                                                        <label><input type="radio" name="aq21" value="0" onChange={handleRadioChnage}/> 전혀 없다</label>
                                                        <label><input type="radio" name="aq21" value="1" onChange={handleRadioChnage}/> 약간 그렇다</label>
                                                        <label><input type="radio" name="aq21" value="2" onChange={handleRadioChnage}/> 꽤 그렇다</label>
                                                        <label><input type="radio" name="aq21" value="3" onChange={handleRadioChnage}/> 심하다</label>
                                                    </dd>
                                                </dl>
                                            </li>
                                        </ul>
                                    </fieldset>
                                <CheckButton goResult={goResult} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PsychlngclCheckAnxiety;